import { useEffect, useRef, useState } from 'react';

import GalleryOffersService from '@/services/galleryOffers.service';

import { buildActiveOfferMap } from '../utils/offer.utils';

export default function useArtworkViewerOffers({
  viewerSessionId,
  isMobileLayout,
  detailsOpen,
  auctionOpen,
}) {
  const [viewerOffersByArtworkId, setViewerOffersByArtworkId] = useState({});
  const loadedViewerOffersSessionRef = useRef(null);
  const shouldLoadViewerOffers = Boolean(
    viewerSessionId
    && (!isMobileLayout || detailsOpen || auctionOpen)
  );

  useEffect(() => {
    let active = true;

    if (!viewerSessionId) {
      setViewerOffersByArtworkId({});
      loadedViewerOffersSessionRef.current = null;
      return () => {
        active = false;
      };
    }

    if (!shouldLoadViewerOffers) {
      return () => {
        active = false;
      };
    }

    if (loadedViewerOffersSessionRef.current === viewerSessionId) {
      return () => {
        active = false;
      };
    }

    async function loadViewerOffers() {
      try {
        const { response, data } = await GalleryOffersService.getMyGalleryOffers({
          status: 'open',
          limit: 40,
        });

        if (!active) {
          return;
        }

        if (!response?.ok) {
          setViewerOffersByArtworkId({});
          return;
        }

        loadedViewerOffersSessionRef.current = viewerSessionId;
        setViewerOffersByArtworkId(buildActiveOfferMap(data?.offers));
      } catch (_error) {
        if (active) {
          setViewerOffersByArtworkId({});
        }
      }
    }

    void loadViewerOffers();

    return () => {
      active = false;
    };
  }, [auctionOpen, detailsOpen, isMobileLayout, shouldLoadViewerOffers, viewerSessionId]);

  return viewerOffersByArtworkId;
}
